import axios from "axios";
import { Field, Form, withFormik } from "formik";
import React from "react";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  CardHeader,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import {
  API_BASE_URL,
  BASE_LOGIN_REDIRECT_URL,
} from "../../constants/api.constants";

const RequestResetPasswordForm = (props) => {
  const { touched, errors, isSubmitting } = props;

  const redirectUrl = () => {
    window.location.replace(`${BASE_LOGIN_REDIRECT_URL}/lwc/#/login`);
  };

  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="8">
            <Form>
              <CardGroup>
                <Card
                  style={{ cursor: "pointer", width: "44%" }}
                  body
                  className="text-white bg-success py-5 d-md-down-none "
                >
                  <div onClick={redirectUrl} title="Tillbaka till loginsidan">
                    <img
                      style={{
                        width: "100%",
                      }}
                      src={"img/LearnWareLoggo.png"}
                      className="img-avatar"
                      alt="LearnWARE logga in"
                    />
                  </div>
                </Card>

                <Card>
                  <CardHeader>
                    <CardTitle
                      className="h3"
                      style={{ marginBottom: "0.25rem" }}
                    >
                      <FormattedMessage id="Views.ResetPassword.ResetPasswordForm.Header" />
                      <i
                        onClick={redirectUrl}
                        title="Tillbaka till loginsidan"
                        style={{ cursor: "pointer" }}
                        className="fa fa-close float-end close"
                      />
                    </CardTitle>
                  </CardHeader>

                  <CardBody>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.ResetPassword.ResetPasswordForm.Body" />
                      </Label>
                      <Field
                        autoFocus={true}
                        className={`form-control ${
                          errors.email && touched.email && "is-invalid"
                        }`}
                        type="email"
                        name="email"
                        autoComplete="username"
                        required
                        placeholder="Ange din e-post"
                      />
                      {errors.email && touched.password && (
                        <div className="invalid-feedback">{errors.email}</div>
                      )}
                    </FormGroup>

                    <Button
                      type="submit"
                      color="success"
                      block
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <FormattedMessage id="Views.ResetPassword.ResetPasswordForm.Label.ButtonPressed" />
                      ) : (
                        <FormattedMessage id="Views.ResetPassword.ResetPasswordForm.Label.Button" />
                      )}
                    </Button>
                  </CardBody>
                </Card>
              </CardGroup>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues({ email }) {
    return {
      email: email || "",
    };
  },

  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    //add student
    axios
      .post(`${API_BASE_URL}/password/resetpassword`, {
        email: values.email,
        isFromApp: false,
      })
      .then((response) => {
        toast.success(
          <FormattedMessage id="Views.ResetPassword.ResetPasswordForm.Success" />,
          {
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            autoClose: 3000,
            onClose: () =>
              window.location.replace(`${BASE_LOGIN_REDIRECT_URL}/`),
          }
        );
        resetForm();
      })
      .catch((err) => {
        setErrors({ email: err.response ? err.response.data : err.message });
      });
    setSubmitting(false);
  },
})(RequestResetPasswordForm);

export default FormikForm;
